import { Rule } from '@travelnest/merlin/rule/Rule';
import * as React from 'react';

interface IChecklistItemProps {
	text: string;
	subtext?: string;
	itemButton?: JSX.Element;
	type?: 'pending' | 'success' | 'star' | 'custom';
	withDivider?: boolean;
	icon?: string;
	backgroundColour?: string;
}

export const ChecklistItem: React.FC<IChecklistItemProps> = (
	{ backgroundColour, icon, type, text, subtext, itemButton, withDivider }
) => {
	const checklistType = type || 'pending';
	const hasButton = typeof itemButton !== 'undefined';
	const iconSrc = type === 'custom' && !!icon ? icon : `/92b3b47/assets/icons/messages/${checklistType}.svg`;

	return <div className={`checklist checklist--${checklistType} checklist--item`}>
		<div className="checklist--item_content">
			<img style={{ backgroundColor: backgroundColour || '' }} src={iconSrc}></img>
			<div className="checklist--item_text">
				{text}
				{subtext && <div className="checklist--item_subtext">{subtext}</div>}
				{hasButton && <div className="checklist--item_button">{itemButton}</div>}
			</div>
		</div>
		{withDivider && <Rule />}
	</div>;
};
